/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ApplicationAuditEventNamespace {
    Application = 1,
    ToDo = 2,
    Hazard = 3,
    Actuals = 4,
    Survey = 5,
    Targets = 6,
}
